import { Currency } from '@flixbus/honeycomb-react';
import { DiscountType, DiscountTypeMap, Voucher } from '../../types/Voucher';
import { OriginalAmount } from '../OriginalAmount';

const OverviewDiscountTypeFields = (discountType: DiscountType, voucher?: Voucher) => {
  const data = discountType;
  const valueFields = [];

  const getPercentage = (amount: number) => {
    return `${(amount * 100).toString()}%`;
  };

  if ('quantity' in data) {
    valueFields.push({
      label: DiscountTypeMap[data.type],
      value: data.quantity,
    });
  }

  if (('credit' in data || data.type === 'value_marketing') && voucher) {
    valueFields.push({
      label: 'Original amount',
      value: <OriginalAmount voucher={voucher} />,
    });
  }

  if ('credit' in data) {
    valueFields.push({
      label: 'Credit balance',
      value: <Currency value={data.credit.amount} code={data.credit.currency} />,
    });
  }

  if ('discount' in data) {
    valueFields.push({
      label: 'Discount balance',
      value: <Currency value={data.discount.amount} code={data.discount.currency} />,
    });
  }

  if ('percentage' in data) {
    valueFields.push({
      label: 'Discount value',
      value: getPercentage(data.percentage),
    });
  }

  return valueFields;
};

export default OverviewDiscountTypeFields;
